import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import LineChart from '../core/LineChart';
import { Playground } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "line-chart-example"
    }}>{`line chart example`}</h1>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <Playground __position={0} __code={'<LineChart\n  showLabel\n  title=\"Concurrent lines\"\n  xType=\"time\"\n  toolboxTooltip={{ saveAsImage: \'saving\' }}\n  dateFormat=\"yyyy-MM\"\n  colors={[\'red\', \'green\', \'blue\']}\n  data={[\n    {\n      name: \'top line\',\n      values: [\n        { label: \'2019-01\', result: 10 },\n        { label: \'2019-02\', result: 40 },\n        { label: \'2019-03\', result: 30 },\n        { label: \'2019-04\', result: 20 },\n        { label: \'2019-05\', result: 40 },\n        { label: \'2019-06\', result: 50 },\n        { label: \'2019-07\', result: 15 },\n        { label: \'2019-08\', result: 70 },\n        { label: \'2019-09\', result: 80 },\n        { label: \'2019-10\', result: 90 },\n        { label: \'2019-11\', result: 70 },\n        { label: \'2019-12\', result: 80 },\n        { label: \'2019-01\', result: 90 },\n      ],\n    },\n    {\n      name: \'bottom line\',\n      values: [\n        { label: \'2019-01\', result: 1 },\n        { label: \'2019-02\', result: 4 },\n        { label: \'2019-03\', result: 3 },\n        { label: \'2019-04\', result: 2 },\n        { label: \'2019-05\', result: 4 },\n        { label: \'2019-06\', result: 5 },\n        { label: \'2019-07\', result: 1 },\n        { label: \'2019-08\', result: 7 },\n        { label: \'2019-09\', result: 8 },\n        { label: \'2019-10\', result: 9 },\n        { label: \'2019-11\', result: 70 },\n        { label: \'2019-12\', result: 80 },\n        { label: \'2019-01\', result: 90 },\n      ],\n    },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      LineChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <LineChart showLabel title='Concurrent lines' xType='time' toolboxTooltip={{
        saveAsImage: 'saving'
      }} dateFormat='yyyy-MM' colors={['red', 'green', 'blue']} data={[{
        name: 'top line',
        values: [{
          label: '2019-01',
          result: 10
        }, {
          label: '2019-02',
          result: 40
        }, {
          label: '2019-03',
          result: 30
        }, {
          label: '2019-04',
          result: 20
        }, {
          label: '2019-05',
          result: 40
        }, {
          label: '2019-06',
          result: 50
        }, {
          label: '2019-07',
          result: 15
        }, {
          label: '2019-08',
          result: 70
        }, {
          label: '2019-09',
          result: 80
        }, {
          label: '2019-10',
          result: 90
        }, {
          label: '2019-11',
          result: 70
        }, {
          label: '2019-12',
          result: 80
        }, {
          label: '2019-01',
          result: 90
        }]
      }, {
        name: 'bottom line',
        values: [{
          label: '2019-01',
          result: 1
        }, {
          label: '2019-02',
          result: 4
        }, {
          label: '2019-03',
          result: 3
        }, {
          label: '2019-04',
          result: 2
        }, {
          label: '2019-05',
          result: 4
        }, {
          label: '2019-06',
          result: 5
        }, {
          label: '2019-07',
          result: 1
        }, {
          label: '2019-08',
          result: 7
        }, {
          label: '2019-09',
          result: 8
        }, {
          label: '2019-10',
          result: 9
        }, {
          label: '2019-11',
          result: 70
        }, {
          label: '2019-12',
          result: 80
        }, {
          label: '2019-01',
          result: 90
        }]
      }]} mdxType="LineChart" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      